import React from 'react';
import { PageLayout } from '../components/global/PageLayout';
import { PageIntro, Section } from '../components/ui/PageIntro';
import { ProductCard } from '../components/LowOnFuel/ProductCard';
import { CTABlock } from '../components/ui/CTABlock';
import { getShopProducts } from '../data/products';
import { IMAGES } from '../data/images';
import { PAGE_META } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
export function Shop() {
  useDocumentMeta({
    ...PAGE_META.shop,
    path: '/shop'
  });
  const shopProducts = getShopProducts();
  return <PageLayout data-id="element-777" data-mp="3dzosjkjqyjye">
      {/* The head band is the merchandise lounge: the whole room the goods
          hang in, rather than a crop of the corner. It shows what someone
          actually walks into — tees, cap, helmets and somewhere to sit. */}
      <PageIntro eyebrow="Shop" title="Low On Fuel Shop" intro="A few of the things on our walls are looking for a new garage. One-off reclaimed pieces, handmade bits from makers near us, and our own tees, caps and snoods. Every one has a real price on it and there is no fuss to any of it." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Shop'
    }]} image={IMAGES.merchandiseLounge.src} data-id="element-778" data-mp="2licj0r4ftgyz" />

      <Section labelledBy="shop-results-heading" data-id="element-779" data-mp="3nc7nx5wqissu">
        <div className="flex flex-wrap items-baseline justify-between gap-4" data-id="element-780" data-mp="3rbybz1uvmuto">
          <h2 id="shop-results-heading" className="font-bebas text-4xl leading-none tracking-wide text-ink" data-id="element-781" data-mp="2ulpd1iprrn4v">
            On the walls
          </h2>
          <p className="text-sm font-medium text-ink-muted" data-id="element-782" data-mp="33m3zwmidtaah">
            {shopProducts.length}{' '}
            {shopProducts.length === 1 ? 'item' : 'items'} available
          </p>
        </div>

        {shopProducts.length > 0 ? <ul className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-id="element-783" data-mp="iwogiclhsnuv">
            {shopProducts.map(product => <li key={product.id} className="flex" data-id="element-784" data-mp="nt52p194ss5b">
                <div className="flex-1" data-id="element-785" data-mp="2jxct7c3pwh6c">
                  <ProductCard product={product} data-id="element-786" data-mp="2jwb6299fg489" />
                </div>
              </li>)}
          </ul> : <p className="mt-8 rounded-container border border-hairline bg-white p-6 text-ink/80" data-id="element-787" data-mp="2twabvyegpghf">
            Nothing on the walls to buy just now. Do pop back soon.
          </p>}
      </Section>

      <CTABlock data-id="element-788" data-mp="217d8t2itnq99" />
    </PageLayout>;
}